import { Select } from '@round/creatorbase-ui';
import { getMaxLastUsedTimeOptions, LastUsedTimeOption } from '../../utils/creatorSearchUtils';
import selectStyles from './selectFilterStyles.module.css';

type Props = {
    value: LastUsedTimeOption | undefined;
    onChange: (value: LastUsedTimeOption | undefined) => void;
};

const anyOption = { label: 'Any', value: 'ANY' };

export const LastUsedFilter = ({ value, onChange }: Props) => {
    const options = getMaxLastUsedTimeOptions();

    return (
        <Select
            className={selectStyles.trigger}
            contentClassName={selectStyles.content}
            options={[anyOption, ...options.map((opt) => ({ label: opt.label, value: String(opt.days) }))]}
            value={value ? String(value.days) : undefined}
            onChange={(option) => {
                if (option === 'ANY') {
                    onChange(undefined);
                }
                onChange(options.find((opt) => String(opt.days) === option));
            }}
            placeholder="Any"
        />
    );
};
